import { Alert, Tabs, Text } from '@conexasaude/conexa-hero'
import { ChooseMultiprofileProps } from './types'
import { FunctionComponent } from 'react'
import { Illustration } from '@/components/RebrandedIllustrations'
import { RenderIf } from '@/components/RenderIf'
import { MainLayout } from '@/modules/Activation/components/MainLayout'
import UserCard from '../UserCard'
import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'
import { useStyles } from './styles'

const ChoiceMultiprofile: FunctionComponent<ChooseMultiprofileProps> = ({
  activeTab,
  activeUsers,
  alertIsOpen,
  currentProfileId,
  inactiveUsers,
  loading,
  users,
  actionBackStepper,
  changeActiveTab,
  handleInactiveUserSelect,
  handleShowDependentsModal,
  handleUserSelect,
  updateSetActiveTab,
  updateSetAlertIsOpen,
}) => {
  const styles = useStyles()
  const { logAnalyticsEvent } = useFirebaseContext()

  return (
    <MainLayout actionBackStepper={actionBackStepper}>
      <div css={styles.pageContainer}>
        <RenderIf condition={inactiveUsers?.length > 0 && !!alertIsOpen}>
          <div css={styles.alertContainer}>
            <Alert
              action={changeActiveTab}
              actionLabel="Ver contas"
              title="Você possui contas pendentes de ativação."
              withCloseButton
              onClose={() => updateSetAlertIsOpen(false)}
              variant="information"
            />
          </div>
        </RenderIf>
        <div css={styles.title}>
          <Text renderAs="h3" variant="headingMedium">
            Qual conta você quer utilizar para acessar?
          </Text>
          <Text variant="paragraphSmall">
            Dependentes crianças e adolescentes estão vinculados ao perfil e CPF
            do titular.
          </Text>
        </div>
        <RenderIf condition={users?.length > 1}>
          <div css={styles.tabsContainer}>
            <Tabs
              fullWidth
              value={activeTab}
              onTabChange={updateSetActiveTab}
              defaultValue="activeUsers"
            >
              <Tabs.List>
                <Tabs.Tab
                  onClick={() => {
                    logAnalyticsEvent('Pac_Clinicas_ContasAtivas')
                  }}
                  value="activeUsers"
                >
                  Contas ativas
                </Tabs.Tab>
                <Tabs.Tab
                  onClick={() => {
                    logAnalyticsEvent('Pac_Clinicas_ContasPendentes')
                  }}
                  notification={
                    inactiveUsers?.length ? inactiveUsers?.length : null
                  }
                  value="pendentUsers"
                >
                  Contas pendentes
                </Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value="activeUsers">
                <div css={styles.cardsContainer}>
                  {activeUsers?.map(user => {
                    return (
                      <UserCard
                        key={user?.id ? user?.id : user?.redirectUrl}
                        clinicUser={user}
                        onActionClick={() => handleUserSelect(user)}
                        isLoading={loading && currentProfileId === user?.id}
                        onLinkClick={() => handleShowDependentsModal(user)}
                      />
                    )
                  })}
                </div>
              </Tabs.Panel>
              <Tabs.Panel value="pendentUsers">
                <div css={styles.cardsContainer}>
                  {inactiveUsers?.map(user => {
                    return (
                      <UserCard
                        key={user?.id}
                        clinicUser={user}
                        onActionClick={() => handleInactiveUserSelect(user)}
                        isLoading={loading && currentProfileId === user?.id}
                      />
                    )
                  })}
                  <RenderIf condition={inactiveUsers?.length === 0}>
                    <div css={styles.containerAllActiveAccounts}>
                      <div css={styles.containerIlustration}>
                        <Illustration
                          name="man-doing-thumbs-with-his-hand"
                          size="135.17px"
                        />
                      </div>
                      <Text variant="headingMedium">
                        Todas as suas contas estão ativas!
                      </Text>
                    </div>
                  </RenderIf>
                </div>
              </Tabs.Panel>
            </Tabs>
          </div>
        </RenderIf>
      </div>
    </MainLayout>
  )
}

export { ChoiceMultiprofile }
